module.exports = __webpack_public_path__ + "static/media/icon_event_yellowred_card.99c37d2b.svg";